(function () {
  function slugify(text, usedSlugs) {
    var slug = text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');

    if (!slug) slug = 'section';

    var unique = slug;
    var i = 2;
    while (usedSlugs.has(unique)) {
      unique = slug + '-' + i;
      i += 1;
    }
    usedSlugs.add(unique);
    return unique;
  }

  function setupSmoothScroll(wrapper) {
    wrapper.querySelectorAll('.toc-link').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var targetId = link.getAttribute('data-toc-target');
        var target = document.getElementById(targetId);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + targetId);
        }
      });
    });
  }

  function setupScrollSpy(wrapper, headings) {
    if (!('IntersectionObserver' in window)) return;

    var links = wrapper.querySelectorAll('.toc-link');
    var linkByTarget = new Map();
    links.forEach(function (link) {
      linkByTarget.set(link.getAttribute('data-toc-target'), link);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var link = linkByTarget.get(entry.target.id);
          if (!link) return;
          links.forEach(function (item) {
            item.classList.remove('is-active');
          });
          link.classList.add('is-active');
        });
      },
      { rootMargin: '0px 0px -70% 0px', threshold: 0 }
    );

    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  // Many articles don't use the theme's dedicated hero-image setting — the writer just
  // drops an <img> (often wrapped in a <p>) as the very first thing in the body instead.
  // If we find that pattern, move the TOC to sit right after it instead of above it.
  function repositionAfterLeadingImage(wrapper, source) {
    var firstElement = source.firstElementChild;

    if (!firstElement) return false;

    var leadingImage = null;

    if (firstElement.tagName === 'IMG') {
      leadingImage = firstElement;
    } else {
      var children = firstElement.children ? Array.prototype.slice.call(firstElement.children) : [];
      var onlyImageInside = children.length === 1 && children[0].tagName === 'IMG';
      var noOtherText = firstElement.textContent.trim() === '';

      if (onlyImageInside && noOtherText) {
        leadingImage = firstElement;
      }
    }

    if (!leadingImage) return false;

    leadingImage.insertAdjacentElement('afterend', wrapper);
    return true;
  }

  function buildToc(wrapper) {
    var selector = wrapper.getAttribute('data-toc-container-selector') || '.article__wrapper .prose';
    var source = document.querySelector(selector);
    if (!source) return;

    var levels = (wrapper.getAttribute('data-toc-levels') || 'h2,h3')
      .split(',')
      .map(function (level) {
        return level.trim();
      })
      .filter(Boolean);

    var minHeadings = parseInt(wrapper.getAttribute('data-toc-min'), 10) || 2;

    // List every heading that matches any of the chosen levels, in document order.
    // Real-world articles are inconsistent — some use h2, some only h3, some both —
    // so we don't assume h2 is present; whatever tags are actually in the content
    // (and match the merchant's chosen levels) get listed and numbered.
    var headings = Array.prototype.slice.call(source.querySelectorAll(levels.join(',')));

    if (headings.length < minHeadings) return;

    var list = wrapper.querySelector('[data-toc-list]');
    if (!list) return;

    var usedSlugs = new Set();

    headings.forEach(function (heading) {
      if (!heading.id) {
        heading.id = slugify(heading.textContent, usedSlugs);
      } else {
        usedSlugs.add(heading.id);
      }
    });

    headings.forEach(function (heading, index) {
      var item = document.createElement('li');
      item.className = 'toc-item';

      var number = document.createElement('span');
      number.className = 'toc-number';
      number.setAttribute('aria-hidden', 'true');
      number.textContent = String(index + 1).padStart(2, '0');

      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      link.className = 'toc-link';
      link.setAttribute('data-toc-target', heading.id);

      item.appendChild(number);
      item.appendChild(link);
      list.appendChild(item);
    });

    list.style.setProperty('--toc-rows', Math.ceil(headings.length / 2));

    repositionAfterLeadingImage(wrapper, source);

    wrapper.hidden = false;
    setupSmoothScroll(wrapper);
    setupScrollSpy(wrapper, headings);
  }

  function init() {
    document.querySelectorAll('[data-toc]').forEach(buildToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
